import CouponsPage from 'components/pages/Coupons';

import { toSidebarFeaturedOffers } from 'lib/offer';
import { resolvify } from 'lib/promises';

import { getAds } from 'services/ads';
import { getCategoriesList } from 'services/category';
import {
  getCouponFeaturedStoresList,
  getCouponPopularStoresList,
  getCouponsList,
} from 'services/coupon';
import { getLandingsList } from 'services/landing';
import { getFeaturedOffersList } from 'services/offer';
import { getSuggestedSearchKeywordsList } from 'services/search';
import { getStoresList } from 'services/store';

import APP from 'constants/app';
import LINKS from 'constants/links';

const COUPONS_LIMIT = 10;
const POPULAR_STORES_LIMIT = 12;

const Coupons = (props) => (
  <CouponsPage {...props} couponsLimit={COUPONS_LIMIT} />
);

export const getServerSideProps = async () => {
  try {
    const [
      serverCoupons,
      popularStores,
      { recommendedOffers },
      featuredStores,
      featuredOffers,
      categories,
      stores,
      featuredLandings,
      highlightedLandings,
      {
        data: {
          topAd: [topbarAd = null],
          topbarHighlight: navbarAds,
        },
      },
    ] = await resolvify([
      getCouponsList({ sort: 'best', limit: COUPONS_LIMIT }),
      getCouponPopularStoresList({ limit: POPULAR_STORES_LIMIT }),
      {
        fn: getSuggestedSearchKeywordsList({ withOffers: true }),
        fallback: { recommendedOffers: [] },
      },
      {
        fn: getCouponFeaturedStoresList(),
        fallback: getCouponFeaturedStoresList.fallback,
      },
      { fn: getFeaturedOffersList(), fallback: getFeaturedOffersList.fallback },
      {
        fn: getCategoriesList({ selectedCategories: true }),
        fallback: getCategoriesList.fallback,
      },
      {
        fn: getStoresList({ from: 'topbar' }),
        fallback: getStoresList.fallback,
      },
      {
        fn: getLandingsList({ featured: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getLandingsList({ highlighted: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getAds(),
        fallback: getAds.fallback,
      },
    ]);

    const sidebarFeaturedOffers = toSidebarFeaturedOffers(
      recommendedOffers,
      featuredOffers
    );

    return {
      props: {
        featuredStores,
        popularStores,
        serverCoupons,
        sidebarFeaturedOffers,
        [APP.CTX_OPTIONAL_PROPS]: {
          categories,
          featuredLandings,
          highlightedLandings,
          navbarAds,
          stores,
          topbarAd,
        },
      },
    };
  } catch {
    return { redirect: { destination: LINKS[500], permanent: false } };
  }
};

export default Coupons;
